import React, { useEffect, useState } from 'react';
import Icon from '@icon-park/react/es/all';
import './PasswordPolicy.scss';
export default function PasswordPolicy({ password }) {
    const [policyFlag, setPolicyFlag] = useState([false, false, false, false]);
    useEffect(() => {
        checkPassordPolicy(password);
    }, [password]);
    const checkPassordPolicy = (value) => {
        setPolicyFlag([value.length > 7, /[A-Z]/.test(value), /[a-z]/.test(value), /\d/.test(value)]);
    };
    return (React.createElement("div", { className: "pasword-policy-wrapper" },
        React.createElement("span", null, "Password must include:"),
        React.createElement("div", null,
            React.createElement(Icon, { type: "check-one", theme: "multi-color", size: 16, fill: policyFlag[0] ? ['#00B93A', '#00B93A', '#fff'] : ['#C2C7C4', '#C2C7C4', '#C2C7C4'] }),
            React.createElement("span", null, "At least 8 characters (the more, the better)")),
        React.createElement("div", null,
            React.createElement(Icon, { type: "check-one", theme: "multi-color", size: 16, fill: policyFlag[1] ? ['#00B93A', '#00B93A', '#fff'] : ['#C2C7C4', '#C2C7C4', '#C2C7C4'] }),
            React.createElement("span", null, "At least 1 uppercase letter")),
        React.createElement("div", null,
            React.createElement(Icon, { type: "check-one", theme: "multi-color", size: 16, fill: policyFlag[2] ? ['#00B93A', '#00B93A', '#fff'] : ['#C2C7C4', '#C2C7C4', '#C2C7C4'] }),
            React.createElement("span", null, "At least 1 lowercase letter")),
        React.createElement("div", null,
            React.createElement(Icon, { type: "check-one", theme: "multi-color", size: 16, fill: policyFlag[3] ? ['#00B93A', '#00B93A', '#fff'] : ['#C2C7C4', '#C2C7C4', '#C2C7C4'] }),
            React.createElement("span", null, "At least 1 number"))));
}
